// Form.js
import React, { useState } from 'react';
import { Container, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import ModalAlert from './modal';

const Form = () => {

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const showAlert = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setModalMessage('');
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const navigate = useNavigate();

  const [tel, setTel] = useState('');
  const [pass, setPass] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();


    if(tel == ''){
      showAlert("연락처를 입력해주세요.");
      return;
    }

    if(pass == ''){
      showAlert("비밀번호를 입력해주세요.");
      return;
    }

    const formData = new FormData();
    formData.append('tel', tel);
    formData.append('pass', pass);
    formData.append('id', id);

    try {
      const response = await axios.post('http://13.124.203.56/sungpt/update_user_phone.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      // console.log('Server response:', response.data);
      showAlert("등록되었습니다.");
      setTimeout(() => {
        navigate('/sungpt'); // 이동할 페이지의 상대 경로
      }, 1000); // 1초 후 이동
    } catch (error) {
      showAlert("등록에 실패하였습니다.");
      // console.error('There was an error uploading the form!', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs"
      sx={{mt: 4}}>

      <div>
        <form onSubmit={handleSubmit} noValidate>

        <ModalAlert
          open={modalOpen}
          onClose={handleClose}
          message={modalMessage}
          />

        <div style={{
          display: 'flex',
          alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'}}>
          <Typography variant="h5" gutterBottom sx={{mt:4, textAlign: 'center'}}>
            매칭 시 연락받을 연락처를 입력해주세요.
          </Typography>

          <Typography variant="h8" gutterBottom sx={{ textAlign: 'center', width: '100%' }}>
             * 매칭 완료 시 sms가 전송됩니다.
          </Typography>
        </div>


            <Grid item xs={12} sx={{mt:4, mb: 2}}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="연락처"
                type="tel"
                value={tel}
                inputProps={{ maxLength: 11 }}
                onChange={(e) => setTel(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sx={{mb: 6}}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="신청확인 비밀번호 4자리"
                type="tel"
                value={pass}
                inputProps={{ maxLength: 4 }} // 최대 글자 수를 10자로 제한
                onChange={(e) => setPass(e.target.value)}
              />
            </Grid>


            <Typography gutterBottom sx={{ textAlign: 'center', width: '100%', fontSize: '14px' }}>
               - 신청 시 귀사의 신청 정보 수집에 동의하게 됩니다.<br />
               - 신청 정보는 제3자에게 제공하지 않으며 즉시 삭제 가능합니다.<br />
            </Typography>

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{mt:2, height:'50px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
          >
            완료
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default Form;
